/**
 * `next` preserves intent across the sign-in wall, and it is **same-origin
 * only**: a caller-supplied cross-origin target is dropped rather than
 * followed (PRD-TDD §11.1).
 */

const FALLBACK = '/';

/** Encodes the current location into a `next` value. */
export function toNextParam(location: { pathname: string; search: string }): string {
  return encodeURIComponent(`${location.pathname}${location.search}`);
}

/**
 * Reads a `next` value back. Anything that is not a single-slash-rooted path —
 * an absolute URL, a protocol-relative `//host`, a backslash variant — resolves
 * to the console root instead.
 */
export function readNextParam(raw: string | null): string {
  if (!raw) return FALLBACK;

  let candidate: string;
  try {
    candidate = decodeURIComponent(raw);
  } catch {
    return FALLBACK;
  }

  if (!candidate.startsWith('/')) return FALLBACK;
  if (candidate.startsWith('//') || candidate.startsWith('/\\')) return FALLBACK;

  return candidate;
}
